import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 0;
  width: 100%;
`;

export const Header = styled.h2`
  color: #e2f1ff;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
  margin-bottom: 24px;
`;

export const Text = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #e9f4ffbf;
  margin: 0;
`;

export const InfoBlock = styled.div`
  background: #e9f4ff06;
  border-radius: 6px;
  padding: 42px;
  display: flex;
  flex-direction: column;
  gap: 42px;

  & iframe {
    height: 500px;
  }

  pre {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #e9f4ffbf;
    margin: 0;
  }

  @media (max-width: 768px) {
    padding: 24px;
  }

  @media (max-width: 600px) {
    padding: 12px;
  }
`;
